import service from '@/utils/server'

const modName='/order/create/';
//查询方法
export const findListByCustomerAndSku = data => {
  return service({
    url: modName + 'findListByCustomerAndSku',
    method: 'post',
    data
  });
};
//初始化页面对象
export const initPage = data => {
  return service({
    url: modName + 'initPage',
    method: 'post',
    data
  });
};

//提交方法
export const orderSubmit = data => {
  return service({
    url: modName + 'submit',
    method: 'post',
    data
  });
};

//文件上传路径
export const uploadUrl = () => {
  return `${process.env.BASE_URL}${modName}uploadOrderFile`;
};

//导入订单
export const uploadOrder = data => {
  let config = {
    responseType: "blob",
    timeout: 500000, // 请求超时时间
    headers: {
      "Content-Type": "multipart/form-data"
    }
  };
  return service({
    ...config,
    url: modName + 'uploadOrder',
    method: 'post',
    data
  });
};

//导入订单模板下载
export const templateOrder = data => {
  let config = {
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'templateOrder/' + data.templateName,
    method: 'post',
    data
  });
};

// 导入订单 导出导入结果
export const uploadOrderResult = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'uploadOrderResult',
    method: 'post',
    data
  });
};







// WEBPACK FOOTER //
// ./src/page/order/create/api/index.js